function SET_COURSES(state, data) {
  state.courses = data;
}

function SET_QUIZZES_BY_COURSE(state, payload) {
  state.quizzesByCourse = {
    ...state.quizzesByCourse,
    [payload.courseId]: payload.quizzes,
  };
}

function SET_CONFIGURATIONS(state, data) {
  state.configurations = data;
}

function SET_SELECTED_INSTANCE_ID(state, instanceId) {
  state.selectedInstanceId = instanceId;
}

function SET_CATEGORIES(state, data) {
  state.categories = data;
}

function REMOVE_COURSE_SLOT_INFO(state, courseId) {
  const courseIndex = state.courses.findIndex(
    (course) => course.id === courseId
  );
  if (courseIndex != -1) {
    delete state.courses[courseIndex].slotId;
    delete state.courses[courseIndex].recruitment_session_id;
    delete state.courses[courseIndex].recruitment_session_name;
  }
}

export default {
  SET_COURSES,
  SET_QUIZZES_BY_COURSE,
  SET_CONFIGURATIONS,
  SET_SELECTED_INSTANCE_ID,
  SET_CATEGORIES,
  REMOVE_COURSE_SLOT_INFO,
};
